import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { onChangeServiceCentersFilter } from '../../../ac/onChangeMapFilters';
import { isochronesServiceCentersFilterValues, ServiceCentersFilterValues } from '../../../constants/variables';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { ColoredItemsLegend } from '../../LegendRenderer/types/ColoredItemsLegend';
import { LEGEND_ICON_TYPES } from '../../../types/legendTypes';
import styles from '../FilterSidebar.module.css';


const IsochronesServiceCentersFilterComponent = ({
    onChangeServiceCentersFilter,
    serviceCentersIsochrones,
}) => {
    const getLabel = val => {
        if (val === 2) {
            return i18n._(t`15 минут (самокат)`);
        }
        if (val === 15) {
            return i18n._(t`15 минут (авто)`);
        }
        if (val === 30) {
            return i18n._(t`30 минут (авто)`);
        }
        return `${val}`;
    };

    return (
        <div>
            <div className={styles.legHead}>{t`Изохроны доступности сервисных центров`}:</div>
            <StandardRadioGroup
                value={String(serviceCentersIsochrones)}
                onChange={onChangeServiceCentersFilter}
            >
                {
                    isochronesServiceCentersFilterValues.map(value => (
                        <FormControlLabel
                            key={value}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={serviceCentersIsochrones === value}
                                    onChange={onChangeServiceCentersFilter}
                                    value={String(value)}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: serviceCentersIsochrones === value,
                                        }
                                    )}
                                    size='small'
                                />
                            }
                            label={getLabel(value)}
                            labelPlacement='end'
                        />
                    ))
                }
            </StandardRadioGroup>
        </div>
    );
};
const ServiceCentersLegendComponent = () => (
    <div>
        <ColoredItemsLegend
            items={ServiceCentersFilterValues.map(({ label, fill }) => ({
                id: fill,
                label: { id: `label_${fill}`, message: i18n._(label) },
                fill,
            }))}
            icon={LEGEND_ICON_TYPES.CIRCLE}
            renderConfig={{
                showIcon: true,
                iconSize: '30px',
                iconOpacity: 0.8,
                fontSize: '0.85rem',
            }}
        />
    </div>
);
const mapStateToProps = ({ mapFilters: { serviceCentersIsochrones } }) => ({ serviceCentersIsochrones });
const ConnectedComponent = connect(mapStateToProps, { onChangeServiceCentersFilter })(IsochronesServiceCentersFilterComponent);

export const ServiceCentersIsochronesFilter = withDisplayedLayersCheck(ConnectedComponent, t`Изохроны доступности сервисных центров`);
export const ServiceCentersIsochronesLegend = withDisplayedLayersCheck(ServiceCentersLegendComponent, t`Изохроны доступности сервисных центров`);
